import React, { useState, useContext }from 'react';
import { IonContent, IonHeader, IonFooter, IonTitle, IonToolbar, IonMenuButton, IonButtons, IonButton, IonItem, IonGrid, IonRow, IonCol, IonInput, IonLabel, IonPage, IonList, IonIcon, IonText } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { useHistory} from "react-router-dom";

import '../../css/layout.css'


//import { SelectDateRange } from '../components/SelectDateRange';
import { Auth_Zasava_Context } from '../../../storeState/Auth_Zasava_Context'


 export function App_Header() {

    let authMerchant_objects = useContext(Auth_Zasava_Context);

    let history = useHistory();

    //alert(authMerchant_objects.employeeCompany);
    //alert(authMerchant_objects.employeeFirstName);


    return (
                <IonHeader>
                            <IonGrid >
                               <IonRow>
                                    <IonCol style={{ textAlign: 'left' }} size='5'>
                                        <IonTitle >zasava</IonTitle>
                                    </IonCol>
                                    <IonCol style={{ textAlign: 'left' }} size='6'>
                                        <IonTitle >{authMerchant_objects.employeeFirstName + ' ' + authMerchant_objects.employeeLastName}</IonTitle>
                                    </IonCol>
                                    <IonCol className='gh_top_links_col_right' size='1'>
                                        <IonMenuButton className="custom-menu-button">x</IonMenuButton>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                        {/*<IonGrid class="DateRangeTab">
                                <IonRow>
                                    <SelectDateRange startDate={-60} endDate={30} />
                                </IonRow>
                        </IonGrid> */}
                </IonHeader>

    );
};
